const DATE_FORMAT = "Y-MM-DD";
const DATETIME_FORMAT = "Y-MM-DD h:mm:ss";
const DATE_PICKER_FORMAT = "Y-m-d";
const NO_IMAGE_URL = "image/no_image.jpg";

export { DATE_FORMAT, DATE_PICKER_FORMAT, DATETIME_FORMAT, NO_IMAGE_URL };
